import type { MutableRefObject } from 'react';
import { useEffect } from 'react';

import { AUTO_SAVE_INTERVAL_MS } from '../constants';
import { selectWorkflowIsSaved } from '../features/ui/selectors';
import { useAppSelector } from '../hooks';

type UseAutoSaveWorkflowParams = {
  workflowId: string | undefined;
  isEnabled: boolean;
  onAutoSave: () => void;
  saveLockRef: MutableRefObject<boolean>;
};

export const useAutoSaveWorkflow = ({
  workflowId,
  isEnabled,
  onAutoSave,
  saveLockRef,
}: UseAutoSaveWorkflowParams): void => {
  const workflowIsSaved = useAppSelector(selectWorkflowIsSaved);

  useEffect(() => {
    // Don't run if toggle is off or no workflowId exists (new workflow)
    if (!isEnabled || !workflowId) {
      return;
    }

    const interval = setInterval(() => {
      // Check conditions: has unsaved changes AND not currently saving
      if (!workflowIsSaved && !saveLockRef.current) {
        onAutoSave();
      }
    }, AUTO_SAVE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isEnabled, workflowId, workflowIsSaved, onAutoSave, saveLockRef]);
};
